import { useQuery } from 'react-query';

import {
  ResultsOrPairingsArgs, TournamentResultsByRound,
} from '~/../api/common.types';
import { api } from '~/client/api';

// get multiple results or pairings
export const useGetResultsOrPairings = ({
  data,
  enabled,
}: {
  data: ResultsOrPairingsArgs;
  enabled: boolean;
}) => {
  return useQuery<TournamentResultsByRound | [], Error>(
    ['get-results-or-pairings', data],
    async () => {
      const matchupsByRound: TournamentResultsByRound | any = [];
      await Promise.all(data.rounds.map(async (round) => {
        try {
          const results = await api.getResults({
            contextId: data.contextId,
            battleId: round,
          });
          const pairings = await api.getPairingsVerbose({
            contextId: data.contextId,
            battleId: round,
          });
          // const sliceAmount = {
          //   9: 1, // don't show 3 & 4th place, 1 & 2 always shown first
          // };
          // const slice = sliceAmount[round];
          // if (slice) {
          //   pairings = pairings.slice(0, slice);
          // }
          const winners = results.flatMap((result) => result.victor);
          pairings.map((pair) => {
            pair.map((warrior)=> {
              warrior.isWinner = winners.includes(warrior.id);
            });
          });
          matchupsByRound.push({ round: round, matchups: pairings });
          // if (round == 6) {
          //   matchupsByRound.push({ round: 7, matchups: pairings.slice(0, 8) });
          //   matchupsByRound.push({ round: 8, matchups: pairings.slice(0, 4) });
          //   matchupsByRound.push({ round: 9, matchups: pairings.slice(0, 2) });
          //   matchupsByRound.push({ round: 10, matchups: pairings.slice(0, 1) });
          // }
        } catch (err: any) {
          // 403 if results are not published
          try {
            const pairings = await api.getPairingsVerbose({
              contextId: data.contextId,
              battleId: round,
            });
            // const sliceAmount = {
            //   9: 1, // don't show 3 & 4th place, 1 & 2 always shown first
            // };
            // const slice = sliceAmount[round];
            // if (slice) {
            //   pairings = pairings.slice(0, slice);
            // }
            matchupsByRound.push({ round: round, matchups: pairings });
            // if (round == 5) {
            //   matchupsByRound.push({ round: 6, matchups: pairings.slice(0, 16) });
            // }
          } catch (_err: any) {
            console.log('error in final', _err);
            // do nothing
          }
        }
      }));
      // sort by round to ensure bracket renders properly
      const sorted = matchupsByRound.slice().sort((a, b) => {
        if (a.round < b.round) return -1;
        return 1;
      });
      return sorted;
    },
    {
      enabled,
    }
  );
};
